module.exports = __webpack_public_path__ + "img/subtitleIcon.6be9ae40.svg";